export const initialImage = {
  uid: '',
  name: '',
  status: undefined,
  url: '',
};
